import RentalRates from "./RentalRates";


export default {
    name     : 'dialog_rental_rates',
    component: RentalRates,
    dialog   : {
        'max-width': "1000px"
    }
}
